import script from "./ScrollToTopFab.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollToTopFab.vue?vue&type=script&setup=true&lang=js"

import "./ScrollToTopFab.vue?vue&type=style&index=0&id=752e1c60&scoped=true&lang=css"

import exportComponent from "/var/www/html/manual/expositores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-752e1c60"]])

export default __exports__